<!-- List Header -->
<header class="o-view-header page-header g-0">
  <div class="c-view-title c-view-title--single-item">
    <h1 class="alpha">
      <ng-container *ngIf="item.resource?.title">
        {{ item.resource.title }}
      </ng-container>
      <ng-container
        *ngIf="!item.resource?.title"
        i18n="@@singleItemView-heading-student-note"
      >
        Student note
      </ng-container>
      <small
        *ngIf="item.resource?.part_of?.title"
        i18n="@@singleItemView-heading-inResource"
      >
        in {{ item.resource.part_of.title }}
      </small>
    </h1>
    <h2 [ngSwitch]="isDraft">
      <ng-container
        *ngSwitchCase="true"
        i18n="@@singleItemView-heading-sharedDraftFrom"
        >Draft item from {{ listTitle }}</ng-container
      >
      <ng-container *ngSwitchDefault i18n="@@singleItemView-heading-sharedFrom"
        >Item from {{ listTitle }}</ng-container
      >
    </h2>
  </div>

  <div class="c-view-actions c-view-actions--single-item">
    <div class="c-view-actions__wrapper">
      <a
        [href]="resourceEditUrl"
        class="btn btn-default btn-lg qa-edit-resource"
        *ngIf="hasListEditPermission"
        i18n="@@singleItemView-btn-editMetadata"
        >Edit metadata</a
      >

      <a [href]="listUrl" class="btn btn-default btn-lg qa-back-btn">
        <ng-container i18n="@@singleItemView-btn-viewList"
          >View list</ng-container
        >
      </a>
    </div>
  </div>
</header>

<article class="c-list-item">
  <ng-container *ngIf="item.resource && resourceImage">
    <img
      alt=""
      class="c-list-item__thumbnail is-expanded disabled"
      [src]="resourceImage"
    />
  </ng-container>

  <div class="c-list-item__content">
    <div *ngIf="item.resource" class="c-list-item__content--info">
      <header class="c-list-item__meta">
        <rl-fielded-resource
          [resource]="item.resource"
          [itemImportance]="item.importance"
          [listId]="listId"
        >
        </rl-fielded-resource>
        <div class="c-list-item__note" *ngIf="item.student_note">
          <span [innerHTML]="item.student_note"></span>
        </div>
      </header>
    </div>

    <div
      *ngIf="!item.resource && item.student_note ? true : false"
      class="c-list-item__note c-list-item__note--standalone"
    >
      <span [innerHTML]="item.student_note | autoLinkUrl"></span>
    </div>

    <div *ngIf="item.resource" class="row c-list-item__detail">
      <!-- Bibliographic resource metadata and availability -->
      <section
        class="c-list-item__availability col-xs-12"
        *ngIf="isNonPageResource"
      >
        <div class="row">
          <rl-resource-availability
            [resource]="item.resource"
            [item]="item"
            [overrideDefaultOnlineResource]="item.defaultOnlineResource"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-resource-availability>
          <rl-item-metadata
            [resource]="item.resource"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-item-metadata>
        </div>
      </section>

      <!-- Page resources should show only the page content -->
      <rl-page-content
        *ngIf="isPageResource && pageContent"
        [pageContent]="pageContent"
        class="list__item__col--content col-xs-12 qa-page-content"
      >
      </rl-page-content>
    </div>
  </div>
</article>
